<template>
  <v-container grid-list-md class="pa-3">
    <v-layout v-if="deal.id && iso.id" justify-center>
      <v-flex xs12 sm10 md7 lg6>
        <v-card flat class="v2-card">
          <v-card-title>Accept Offer and Request Contract Form</v-card-title>
          <v-card-text v-if="formStatus === 0">
            <v-form onSubmit="return false;" ref="form" lazy-validation>
              <v-layout row wrap>
                <v-flex v-for="f in offerFacts" :key="f.label" xs6 sm4>
                  <div class="v2-kpi-label">{{ f.label }}</div>
                  <div class="font-weight-bold">{{ f.value }}</div>
                </v-flex>
              </v-layout>

              <div class="v2-kpi-label mt-3">Commission %</div>
              <v-slider v-model="slider" :max="max" :min="min" thumb-label="always" class="mt-4" @change="calculatePayment"></v-slider>

              <p class="v2-muted">Note: <span v-html="offer.offer_notify_note"></span></p>

              <p class="mb-2">Please attach Driver License and Void Check to order contract:</p>
              <div class="v2-dropzone">
                <input type="file" id="files" ref="files" multiple @change="handleFiles()" />
                <v-icon large color="primary">cloud_upload</v-icon>
                <div class="v2-muted">Drop your files here or click to search</div>
              </div>

              <v-card v-for="(file, key) in files" :key="key" flat class="v2-card v2-panel pa-2 mt-2">
                <v-layout row wrap align-center>
                  <v-flex xs12 sm5>
                    <img class="v2-preview" :ref="'preview' + key" height="70" width="100" />
                    <div class="caption">{{ file.fileUploaded.name }}</div>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-select v-model="file.category_id" :rules="[v => !!v || 'File Category is required']" :items="categories" item-text="file_category_name" item-value="id" label="File Category" outline dense required></v-select>
                  </v-flex>
                  <v-flex xs12 sm2 class="text-xs-right">
                    <v-chip v-if="file.id > 0" small color="success" text-color="white">Success</v-chip>
                    <v-btn v-else flat small color="error" @click="removeFile(key)">Remove</v-btn>
                  </v-flex>
                </v-layout>
              </v-card>

              <div class="mt-3">
                <vue-editor id="note" placeholder="How would you like to receive contracts? Send E-Sign directly to merchant(s) or Email as attachment?" v-model="iso_message" :editorToolbar="customToolbar"></vue-editor>
              </div>
              <v-btn color="primary" depressed class="ml-0 mt-3" @click="sendNotification" :disabled="progressModel">Submit</v-btn>
            </v-form>
          </v-card-text>
          <v-card-text v-else>
            <p>Your contract request has been processed. We will get back to you shortly.</p>
            <p class="mb-0">Thank you,</p>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="progressModel" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>Please stand by<v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear></v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import acceptOffer from '../mixins/acceptOffer'

export default {
  mixins: [acceptOffer],
  components: { VueEditor },
  computed: {
    offerFacts() {
      const currency = this.$options.filters.currency
      return [
        { label: 'Position Number', value: this.offer.lender_position_number },
        { label: 'Offer Amount', value: currency(this.offer.lender_offer_amount) },
        { label: 'Payback Amount', value: currency(this.offer.lender_payback_amount) },
        { label: 'Max Upsell', value: this.offer.lender_factor_rate },
        { label: 'Buy Rate', value: this.offer.lender_buy_rate },
        { label: 'Payment', value: `${currency(this.offer.lender_payment)} ${this.offer.lender_payment_type}` },
        { label: 'Term', value: `${this.offer.lender_term} Days` },
      ]
    },
  },
}
</script>

<style scoped>
.v2-dropzone { position: relative; border: 2px dashed #CBD5E1; border-radius: 12px; padding: 24px; text-align: center; background: #F8FAFC; }
.v2-dropzone input { position: absolute; inset: 0; width: 100%; height: 100%; opacity: 0; cursor: pointer; }
.v2-preview { object-fit: cover; border-radius: 6px; background: #E2E8F0; }
</style>
